/*eslint no-unused-vars: "off"*/
import { WebSocketManagerObject } from "./webSocketManager";

global.connect = global.connect || {};
connect.WebSocketManager = WebSocketManagerObject;

export const WebSocketManager = WebSocketManagerObject;

export default WebSocketManager;